import { useEffect, useState } from "react"
import { useLocation } from "react-router-dom"

export default function useExpandableMenuTracker() {
  const { pathname } = useLocation()
  const [expandedMenuItems, setExpandedMenuItem] = useState([])
  const [lastClicked, setLastClicked] = useState({})

  const expandedTracker = el => {
    const set = new Set(expandedMenuItems)
    if (set.has(el)) {
      set.delete(el)
    } else {
      set.add(el)
    }

    setExpandedMenuItem([...set])
  }

  useEffect(() => {
    if (lastClicked.parent) {
      setExpandedMenuItem([...lastClicked.parent])
    }
  }, [pathname])

  return {
    expandedTracker,
    setLastClicked,
    expandedMenuItems,
  }
}
